import { recentSearchUrl, useClearSearchHistory } from '@/logic/services';
import { useDialog, useSnack } from '@/logic/state';

import { ConfirmDialog } from '../shared/confirm-dialog';
import { FC } from 'react';
import { QueryKeyType } from '@/logic/libs';
import shallow from 'zustand/shallow';
import { useQueryClient } from '@tanstack/react-query';

const ClearHistoryFindingIcon = '/icons//movie-finder/clear-history-finding-icon.svg';

export const ClearHistoryConfirmDialog: FC = () => {
  const [setDialog] = useDialog(s => [s.setDialog], shallow);
  const setSnack = useSnack(s => s.setSnack, shallow);

  const queryClient = useQueryClient();

  const { mutate: clearHistory, isLoading: isClearingHistory } = useClearSearchHistory(
    {},
    {
      onSuccess: () => {
        setSnack({
          isOpen: true,
          message: 'movie_finder.search.clear.success',
          type: 'success',
        });

        queryClient.invalidateQueries({
          predicate: query => {
            return (query.queryKey[0] as QueryKeyType)?.url === recentSearchUrl;
          },
        });
        setDialog({});
      },
      onError: () => {
        setSnack({
          isOpen: true,
          message: 'global.error',
          type: 'error',
        });
      },
    }
  );

  const handleClearHistory = () => {
    clearHistory({});
  };

  return (
    <ConfirmDialog
      buttonId='clear_history.delete'
      img={ClearHistoryFindingIcon}
      widthImage='99px'
      heightImage='106px'
      altImage='alt.delete_voucher_icon'
      title='movie_finder.search.clear.confirm.title'
      description='movie_finder.search.clear.confirm.description'
      handleOkayClick={handleClearHistory}
      handleCloseClick={() => setDialog({})}
      isLoading={isClearingHistory}
    />
  );
};
